namespace Gamification.Gamification {


    export function selectTabByEditor(editor: Serenity.Widget<any>) {
        let tabId = editor.element.closest('.tab-pane').attr('id');
        let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);
        (tabAnchor as any).tab('show');

        //tabAnchor[0].outerHTML	"<a class="nav - link" data-bs-toggle="tab" role="tab" href="#Serenity_PropertyGrid8_Tab1">2sws</a>"	string
        //selectTabByEditor(this.form.MobilePhoneNumber);
    }

    export function getIsSelectedTabByEditor(editor: Serenity.Widget<any>): boolean {
        var bSelected = false;
        let tabId = editor.element.closest('.tab-pane').attr('id');
        let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);
        var nIndice = tabAnchor[0].outerHTML.indexOf('active');
        if (nIndice >= 0) {
            //Q.notifyInfo("Selected tab: " + nIndice.toString());
            bSelected = true;
        }
        return bSelected;

        // Get current tab
        //var currentTab = Serenity.TabsExtensions.activeTabKey(this.tabs);
        //Q.notifyInfo(currentTab);
        //$("#TabList").tabs('option', 'active');
        //var b = (tabAnchor as any).tabs('option', 'active');
        //tabAnchor[0].outerHTML	"<a class="nav - link" data-bs-toggle="tab" role="tab" href="#Serenity_PropertyGrid8_Tab1">2sws</a>"	string

        //getIsSelectedTabByEditor(this.form.MobilePhoneNumber);
    }

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.resizable()
    export class ApiScriptUtenteDialog extends Serenity.PropertyDialog<any, any> {
        protected getFormKey() { return ApiScriptUtenteForm.formKey; }

        protected form = new ApiScriptUtenteForm(this.idPrefix);

        constructor() {
            super();
        }

        /**
         * Here we override loadInitialEntity method to set value for "DisplayFieldValue" field.
         * If this was an EntityDialog, your field value would be originating from server side entity.
         */
        protected loadInitialEntity() {
            this.propertyGrid.load({
                VisualizzaApi: ''
            });
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = "API Script utente";
            opt.height = 600
            opt.width = 800;
            return opt;
        }

        protected getToolbarButtons() {
            Q.notifyInfo("A");
            var buttons = super.getToolbarButtons();

            // Add button
            buttons.push({
                title: 'Esporta',
                onClick: () => { /*Add Function Here */

                    //Q.notifyInfo(this.form.IdProdotto.value);
                    //Q.notifyInfo(this.form.IdApi.value);
                    //Q.notifyInfo(this.form.Operazione.value);

                    var nIdProdotto = +(this.form.IdProdotto.value);
                    var nIdApi = +(this.form.IdApi.value);

                    if (nIdProdotto == 0) {
                        Q.notifyWarning("Selezionare il prodotto da utilizzare.")
                    }

                    if (nIdApi == 0) {
                        Q.notifyWarning("Selezionare l'API da utilizzare.")
                    }

                    // Get current tab
                    //var currentTab = Serenity.TabsExtensions.activeTabKey(this.tabs);
                    //Q.notifyInfo(currentTab);

                    if (false) {

                        var nIdApiOperazione = +(this.form.IdApiOperazione.value);

                        if (nIdApiOperazione == 0) {
                            Q.notifyWarning("Selezionare l'operazione da utilizzare.")
                        }

                        if (nIdProdotto > 0 &&
                            nIdApi > 0 &&
                            nIdApiOperazione > 0) {

                            var theCriteria = Serenity.Criteria.and([[Gamification.ApiComandiRow.Fields.IdApi], '=', nIdApi], [[Gamification.ApiComandiRow.Fields.IdApiOperazione], '=', nIdApiOperazione]);

                            Gamification.ApiComandiService.List({
                                Criteria: theCriteria,
                                IncludeColumns: ["Comando", "Descrizione"]
                            }, response => {
                                var theEntities = response.Entities;
                            });
                        }
                    }

                    if (false) {

                        var nIdProdottoBadge = +(this.form.IdProdottoBadge.value);

                        if (nIdProdottoBadge == 0) {
                            Q.notifyWarning("Selezionare il badge da utilizzare.")
                        }

                        Gamification.ProdottiBadgeService.Retrieve({
                            EntityId: nIdProdottoBadge
                        }, response => {
                            if (this.form.BadgeMostra) {
                                this.form.BadgeImmagineFileName.props.value = response.Entity.ImmagineOttenuto;
                            }
                            else { this.form.BadgeImmagineFileName.props.value = response.Entity.ImmagineNonOttenuto; }
                        })
                    }

                    if (false) {

                        var nIdProdottoEsperienza = +(this.form.IdProdottoEsperienza.value);

                        if (nIdProdottoEsperienza == 0) {
                            Q.notifyWarning("Selezionare l'esperienza da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeService.Retrieve({
                            EntityId: nIdProdottoEsperienza
                        }, response => {
                            if (true) { Q.notifySuccess(response.Entity.Nome); }
                        })

                    }

                    if (true) {

                        var nIdProdottoEsperienzaTask = +(this.form.IdProdottoEsperienzaTask.value);

                        if (nIdProdottoEsperienzaTask == 0) {
                            Q.notifyWarning("Selezionare il task da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeTaskService.Retrieve({
                            EntityId: nIdProdottoEsperienzaTask
                        }, response => {
                            if (true) { Q.notifySuccess(response.Entity.Nome); }
                        })
                    }

                }
            });

            Q.notifyInfo(buttons.length.toString());

            return buttons;
        }

        protected getDialogButtons() {
            var buttons = super.getDialogButtons();

            // Add button
            buttons.unshift({
                text: 'Esporta',
                click: () => { /*Add Function Here */

                    var nIdProdotto = +(this.form.IdProdotto.value);
                    var nIdApi = +(this.form.IdApi.value);

                    if (nIdProdotto == 0) {
                        Q.notifyWarning("Selezionare il prodotto da utilizzare.")
                    }

                    if (nIdApi == 0) {
                        Q.notifyWarning("Selezionare l'API da utilizzare.")
                    }

                    if (getIsSelectedTabByEditor(this.form.IdApiOperazione)) {

                        var nIdApiOperazione = +(this.form.IdApiOperazione.value);

                        if (nIdApiOperazione == 0) {
                            Q.notifyWarning("Selezionare l'operazione da utilizzare.")
                        }

                        if (nIdProdotto > 0 &&
                            nIdApi > 0 &&
                            nIdApiOperazione > 0) {

                            var theCriteria = Serenity.Criteria.and([[Gamification.ApiComandiRow.Fields.IdApi], '=', nIdApi], [[Gamification.ApiComandiRow.Fields.IdApiOperazione], '=', nIdApiOperazione]);

                            Gamification.ApiComandiService.List({
                                Criteria: theCriteria,
                                IncludeColumns: ["Comando", "Descrizione"]
                            }, response => {
                                var theEntities = response.Entities;
                                //Q.notifyInfo(theEntities.toString());
                                //
                                if (theEntities.length > 0) {
                                    var theDialog = new ApiScriptCodiceDialog();
                                    theDialog.Codice = theEntities[0].Comando;
                                    theDialog.Descrizione = theEntities[0].Descrizione;
                                    theDialog.dialogOpen(false);
                                }
                                else {
                                    Q.notifyWarning("Il comando desiderato non è disponibile.");
                                }
                            });
                        }
                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoBadge)) {

                        var nIdProdottoBadge = +(this.form.IdProdottoBadge.value);

                        if (nIdProdottoBadge == 0) {
                            Q.notifyWarning("Selezionare il badge da utilizzare.")
                        }

                        Gamification.ProdottiBadgeService.Retrieve({
                            EntityId: nIdProdottoBadge
                        }, response => {
                            if (this.form.BadgeMostra) {
                                this.form.BadgeImmagineFileName.props.value = response.Entity.ImmagineOttenuto;
                            }
                            else { this.form.BadgeImmagineFileName.props.value = response.Entity.ImmagineNonOttenuto; }

                            //
                            var theDialog = new ApiScriptCodiceDialog();
                            theDialog.Codice = "Codice da inserire.";
                            theDialog.dialogOpen(false);
                        });
                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoEsperienza)) {

                        var nIdProdottoEsperienza = +(this.form.IdProdottoEsperienza.value);

                        if (nIdProdottoEsperienza == 0) {
                            Q.notifyWarning("Selezionare l'esperienza da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeService.Retrieve({
                            EntityId: nIdProdottoEsperienza
                        }, response => {
                            if (true) {
                                Q.notifySuccess(response.Entity.Nome);
                                //
                                var theDialog = new ApiScriptCodiceDialog();
                                theDialog.Codice = "Codice da inserire.";
                                theDialog.dialogOpen(false);
                            }
                        })

                    }

                    if (getIsSelectedTabByEditor(this.form.IdProdottoEsperienzaTask)) {

                        var nIdProdottoEsperienzaTask = +(this.form.IdProdottoEsperienzaTask.value);

                        if (nIdProdottoEsperienzaTask == 0) {
                            Q.notifyWarning("Selezionare il task da utilizzare.")
                        }

                        Gamification.ProdottiEsperienzeTaskService.Retrieve({
                            EntityId: nIdProdottoEsperienzaTask
                        }, response => {
                            if (true) {
                                Q.notifySuccess(response.Entity.Nome);
                                //
                                var theDialog = new ApiScriptCodiceDialog();
                                theDialog.Codice = "Codice da inserire.";
                                theDialog.dialogOpen(false);
                            }
                        })
                    }

                }
            });

            // Remove button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "btn-primary"), 1);

            return buttons;
        }
    }
}
